// @flow
import React from 'react';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import { type Match } from 'react-router-dom';
import PlainTemplate from 'components/common/PlainTemplate';
import SeriesContainer from 'containers/series/SeriesContainer';
import PageTemplate from 'components/base/PageTemplate';

type Props = {
  match: Match,
};

const Series = ({ match }: Props) => {
  return (
    <PageTemplate>
      <header>
        <MainHeadContainer />
        <MainMobileHeadContainer />
      </header>
      <PlainTemplate>
        <SeriesContainer />
      </PlainTemplate>
      <MainMobileFooter />
    </PageTemplate>
  );
};

export default Series;



// WEBPACK FOOTER //
// ./src/pages/Series.js